import React from 'react'
import { Button, Flex } from '@workwhile/ui'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useIndeedFlexCompaniesContextValue } from '../context/IndeedFlexCompaniesProvider'
import { useIndeedFlexCompaniesWorkflowsContextValue } from '../context/IndeedFlexCompaniesWorkflowsProvider'

export const IndeedFlexCompaniesHeader = () => {
  const { state, actions } = useIndeedFlexCompaniesContextValue()
  const { createCompanyFlow } = useIndeedFlexCompaniesWorkflowsContextValue()

  return (
    <Header
      title="Indeed Flex Companies"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
          <Button
            variant="primary"
            kind="medium"
            onClick={createCompanyFlow.open}
          >
            Add company
          </Button>
        </Flex>
      }
    />
  )
}
